var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark"},[_c('InsideBanner'),_c('h1',{staticClass:"inside_page_name"},[_vm._v("Awards")]),_c('PCard',{attrs:{"piece":_vm.loadedPiece,"editable":_vm.editable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }